import React from 'react';
import { Tabs, Tab } from '@mui/material';
import ChatHeader from '../../../components/chat-header';
import MissionCard from '../../../components/v2/mission-card';
import { LevelStatusTab } from './components/LevelStatusTab';
import { useAllMissions } from './hooks/useAllMissions';
import './user-all-missions.scss';

export default function UserAllMissions() {
  const {
    t,
    navigate,
    tabValue,
    handleTabChange,
    openMissions,
    completedMissions,
    isLoading,
    handleMissionPress
  } = useAllMissions();

  return (
    <div className="v2-all-missions-page">
      <ChatHeader 
        chatHeading={t('allMissions')} 
        onBackClick={() => navigate(-1)} 
      />

      <div className="v2-missions-tabs-container">
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          centered 
          variant="fullWidth"
          className="v2-missions-tabs"
        >
          <Tab label={t('openMissionsShort')} />
          <Tab label={t('completedMissionsShort')} />
          <Tab label={t('levelStatusTabShort')} />
        </Tabs>
      </div>

      <div className="v2-missions-content">
        {isLoading ? (
          <div className="v2-missions-grid">
            {[1, 2, 3].map(i => (
              <MissionCard key={i} title="" completed={0} total={0} percentage={0} loading={true} />
            ))}
          </div>
        ) : (
          <div className="v2-missions-grid">
            {tabValue === 0 ? (
              openMissions.length > 0 ? (
                <div className="v2-missions-sections">
                  {/* Lessons Section */}
                  {openMissions.filter(m => m.type === 'lesson').length > 0 && (
                    <div className="v2-mission-type-section">
                      <h3 className="v2-mission-section-title">{t('lessons')}</h3>
                      <div className="v2-mission-section-list">
                        {openMissions.filter(m => m.type === 'lesson').map(m => (
                          <MissionCard
                            key={m.id}
                            type="lesson"
                            title={m.full_topic_label || ''}
                            completed={m.completed_count}
                            total={m.total_count}
                            percentage={m.percentage}
                            status={m.status as 0 | 1 | 2}
                            onPress={() => handleMissionPress(m)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {/* Exercises Section */}
                  {openMissions.filter(m => m.type === 'exercise').length > 0 && (
                    <div className="v2-mission-type-section">
                      <h3 className="v2-mission-section-title">{t('exercises')}</h3>
                      <div className="v2-mission-section-list">
                        {openMissions.filter(m => m.type === 'exercise').map(m => (
                          <MissionCard
                            key={m.id}
                            type="exercise"
                            title={m.full_topic_label || ''}
                            completed={m.completed_count}
                            total={m.total_count}
                            percentage={m.percentage}
                            status={m.status as 0 | 1 | 2}
                            onPress={() => handleMissionPress(m)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="empty-state">
                  <p>{t('noMissionsYet')}</p>
                </div>
              )
            ) : tabValue === 1 ? (
              completedMissions.length > 0 ? (
                <div className="v2-missions-sections">
                  {/* Lessons Section */}
                  {completedMissions.filter(m => m.type === 'lesson').length > 0 && (
                    <div className="v2-mission-type-section">
                      <h3 className="v2-mission-section-title">{t('lessons')}</h3>
                      <div className="v2-mission-section-list">
                        {completedMissions.filter(m => m.type === 'lesson').map(m => (
                          <MissionCard
                            key={m.id}
                            type="lesson"
                            title={m.full_topic_label || ''}
                            completed={m.completed_count}
                            total={m.total_count}
                            percentage={m.percentage}
                            status={m.status as 0 | 1 | 2}
                            onPress={() => handleMissionPress(m)}
                          />
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Exercises Section */}
                  {completedMissions.filter(m => m.type === 'exercise').length > 0 && (
                    <div className="v2-mission-type-section">
                      <h3 className="v2-mission-section-title">{t('exercises')}</h3>
                      <div className="v2-mission-section-list">
                        {completedMissions.filter(m => m.type === 'exercise').map(m => (
                          <MissionCard
                            key={m.id}
                            type="exercise"
                            title={m.full_topic_label || ''}
                            completed={m.completed_count}
                            total={m.total_count}
                            percentage={m.percentage}
                            status={m.status as 0 | 1 | 2}
                            onPress={() => handleMissionPress(m)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="empty-state">
                  <p>{t('noMissionsYet')}</p>
                </div>
              )
            ) : (
              <LevelStatusTab t={t} />
            )}
          </div>
        )}
        <div className="v2-all-missions-bottom-spacer" />
      </div>
    </div>
  );
}
